module.exports = __webpack_public_path__ + "7ca7d017041b134488cdd7f99b4b6b8d.svg";